import { Model } from './model';

export enum PlaybookCollection {
  CashApplication = 'cash_application',
  Collections = 'collections',
  Company = 'company',
  CreditRisk = 'credit_risk',
  Deductions = 'deductions',
  Disputes = 'disputes',
  Payments = 'payments',
}

export class KnowledgeCitation extends Model {
  id: string;

  agent: string;

  agent_reasoning: string;

  article_id: string;

  article_collection: PlaybookCollection;

  article_title: string;

  excerpt: string;

  version_number: number;
}
